import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { ToastHeader as ToastHeader$1 } from 'reactstrap';

var ToastHeader = function (_a) {
    var children = _a.children, closeAriaLabel = _a.closeAriaLabel, Icon = _a.Icon, onClose = _a.onClose, _b = _a.tag, tag = _b === void 0 ? 'span' : _b, props = __rest(_a, ["children", "closeAriaLabel", "Icon", "onClose", "tag"]);
    return (jsx(ToastHeader$1, __assign({ closeAriaLabel: closeAriaLabel, "data-testid": "toast-header", icon: Icon && jsx(Icon, { "data-testid": "toast-icon", className: "toast-icon" }), tag: tag, toggle: onClose }, props, { children: children })));
};
ToastHeader.displayName = 'Toast.Header';

export { ToastHeader };
